



























































import { Component, Vue, Watch } from "vue-property-decorator";
import loader from "@/components/loader.vue";

import { momentTZ as moment } from "@/helpers/moment";
import billingApi from "@/services/billing";
import { debounce, cancel } from "typescript-debounce-decorator";
import { Action, Getter, Mutation } from "vuex-class";
import { WarehousePackage } from "@/models/warehousePackage";
import AccountCell from "@/components/cells/Account.vue";

import { NSLog } from "@/helpers/log";
import { find as FindAccountDialog } from "@/dialogs/account";
import billing from "@/services/billing";
import { Permission } from '@/models/permission';
import { Account } from '@/models/account'
import Loader from '../../components/loader.vue'
const log = NSLog("view/ManageUsers");

@Component({
  components: {
    loader,
    AccountCell,
    FindAccountDialog
  },
})
export default class ManageUsers extends Vue {
  loading = true;
  permissions: Permission[] = [];
  allPermissionTypes: string[] = [];
  byAccount: any[] = [];
  searchAccountDialog = false;

  @Mutation("setLastErr") public setLastErr: any;

  mounted() {
    this.loadPermissions();
  }

  async loadPermissions() {
    try {
      const perms = await billing.listAllUserPermissions()
      this.permissions = perms;
    } catch (err) {
      this.setLastErr(err);
    }

    const permTypes = {} as any;
    const byAccMap = this.permissions.reduce((prev, curr) => {
      permTypes[curr.permission] = true;
      prev[curr.account_id] = prev[curr.account_id] || {};
      prev[curr.account_id][curr.permission] = curr;
      curr._loading = false;
      return prev;
    }, ({} as any));

    this.byAccount = Object.keys(byAccMap).map((account_id) => ({ account_id, ...byAccMap[account_id] }));
    this.allPermissionTypes = Object.keys(permTypes);

    this.loading = false;
  }


  get headers() {
    const hdrs: any = [
      //  "account_id": 26, "permission": "orderingadmin", "can_read": true, "can_write": true, "can_delete": true, "created_at": 1505458142, "updated_at": 1505458142 
      { text: "Account", value: "account_id" },
      // {
      //   text: "Permission",
      //   align: "left",
      //   sortable: true,
      //   value: "title",
      // },
      // { text: "Created", value: "created_at" },
      // { text: "Updated", value: "updated_at" },
      ...this.allPermissionTypes.map((v) => ({ text: v, value: "-", sortable: false })),
    ];
    return hdrs;
  }

  private async togglePermission(
    account_id: number,
    permission: string,
    canX: 'can_read' | 'can_write' | 'can_delete',
    enabled: boolean
  ) {
    return new Promise<Permission>(async (resolve, reject) => {
      let perm = this.permissions.find((v) => account_id == v.account_id && permission == v.permission);
      if (!perm) {
        perm = ({ account_id, permission } as Permission);
        this.permissions.push(perm);
      }
      perm[canX] = enabled;
      perm._loading = true;
      try {
        await billing.setUserPermission(+perm.account_id, perm.permission, perm.can_read, perm.can_write, perm.can_delete);
      } catch (err) {
        this.setLastErr(err);
        reject(err);
      }
      perm._loading = false;

      setTimeout(() => {
        this.byAccount = [...this.byAccount];
        this.allPermissionTypes = [...this.allPermissionTypes];
        resolve(perm as Permission);
      }, 100);
    })
  }

  private async addAccount(account: Account | false) {
    if (!account) {
      this.searchAccountDialog = false;
      return;
    }
    this.searchAccountDialog = false;
    this.loading = true;
    await this.togglePermission(account.id, 'orderingadmin', 'can_read', true);
    await this.loadPermissions();
    this.loading = false;
  }

}
